import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MultiYearAuctionsResource } from 'angular/resources/multi-year-auctions.resource';
import { TimeHelperUtils } from 'angular/utils/time-helper.utils';
import { Growl } from 'angular/custom/services/growl.service';
import { ConfirmModal } from 'angular/custom/services/confirm-modal.service';
import { Observable } from 'rxjs';
import { ErrorHandlerService } from 'angular/custom/services/error-handler.service';

@Component({
    selector: 'multi-year-bid-overview',
    template: require('./multi-year-bid-overview.component.html')
})
export class MultiYearBidOverviewComponent implements OnInit {
    public loading = true;

    @Input() public auctionId: number;
    @Input() public allowEdit = false;
    @Input() public bidCreated?: Observable<MultiYearCfoBidDto>;
    @Output() public bidEditClicked = new EventEmitter<MultiYearCfoBidDto>();
    @Output() public bidDeleted = new EventEmitter<MultiYearCfoBidDto>();

    public bids: MultiYearCfoBidDto[];

    constructor(
        private multiYearAuctionsResource: MultiYearAuctionsResource,
        private growl: Growl,
        private confirmModal: ConfirmModal,
        private errorHandlerService: ErrorHandlerService
    ) {}

    public ngOnInit(): void {
        if (this.auctionId) {
            this.multiYearAuctionsResource
                .getBidsForAuction(this.auctionId)
                .subscribe(
                    (bids) => {
                        this.bids = bids;
                        this.loading = false;
                    },
                    (err) =>
                        this.errorHandlerService.handle(
                            err,
                            'Your bids could not be loaded.'
                        )
                );
        }

        this.bidCreated != null &&
            this.bidCreated.subscribe((bid: MultiYearCfoBidDto) => {
                const idxOfExistingBid = this.bids.findIndex(
                    (b) => b.bidId === bid.bidId
                );
                idxOfExistingBid !== -1
                    ? (this.bids[idxOfExistingBid] = bid)
                    : this.bids.push(bid);
            });
    }

    public editClicked(bid: MultiYearCfoBidDto) {
        this.bidEditClicked.emit(bid);
    }

    public deleteClicked(bid: MultiYearCfoBidDto) {
        this.confirmModal
            .fromText(
                `You cannot undo this action, so you will need to submit a new bid if you accidentally delete the bid.`,
                'Are you sure you want to delete this bid?'
            )
            .subscribe((confirm) => {
                if (confirm) {
                    this.multiYearAuctionsResource
                        .deleteBid(bid.auctionId, bid.bidId)
                        .subscribe(
                            () => {
                                this.growl.show(
                                    'Bid deleted successfully.',
                                    'success'
                                );
                                this.bids = this.bids.filter(
                                    (aBid) =>
                                        !(
                                            bid.bidId === aBid.bidId &&
                                            bid.auctionId === aBid.auctionId
                                        )
                                );
                            },
                            (err) =>
                                this.errorHandlerService.handle(
                                    err,
                                    'Bid could not be placed.'
                                )
                        );
                }
            });
    }

    public getTimezoneForDate(date) {
        return TimeHelperUtils.isCentralEuropeanSummerTime(date)
            ? '+0200'
            : '+0100';
    }
}
